export enum TagPaymentLabel {
	Paid = 'Pago',
	Pending = 'Pagto. Pendente',
	Renew = 'Anúncio Renovado'
}
